export default __webpack_public_path__ + "locales/vi/EmptyView.json?hash=1e67331644e2909b04d9b31ad9e70c1d";